import notNull from "./utils/notNull";

let _userInfo =
  localStorage.getItem("User_Info") !== null
    ? JSON.parse(localStorage.getItem("User_Info"))
    : {
        login: "",
        nome: "",
        perfil: "",
        prefeituraId: undefined,
        usuarioId: undefined,
        prefeituraSelecionadaId: undefined,
        municipioId: undefined,
      };

export default class UserInfo {
  static estaAutenticado() {
    this.controlarValidadeToken();

    const usuarioId = _userInfo === undefined ? undefined : _userInfo.usuarioId;
    return usuarioId !== undefined;
  }

  static gerenciaPrefeitura() {
    this.controlarValidadeToken();

    if (!notNull(_userInfo)) {
      return false;
    }

    return !notNull(_userInfo.prefeituraId);
  }

  static setUsuario(e) {
    //if (UserInfo.gerenciaPrefeitura()) {
    localStorage.setItem("User_Info", JSON.stringify(e));
    // _userInfo.nome = e.nome;
    // _userInfo.login = e.login;
    // _userInfo.prefeituraSelecionadaId = e.prefeituraId;
    // _userInfo.prefeituraId = e.prefeituraId;
    // _userInfo.municipioId = e.municipioId;
    // _userInfo.usuarioId = e.usuarioId;
    //}
    //forcarUpdate();
  }

  static possuiRecurso(recurso) {
    return _userInfo.permissoes.includes(recurso);
  }

  static SelecionarPrefeitura(e) {
    this.controlarValidadeToken();

    if (this.gerenciaPrefeitura()) {
      _userInfo.prefeituraSelecionadaId = e;
      this.setUsuario(_userInfo);
    }
  }

  static controlarValidadeToken() {
    const dataCorrente = new Date();

    if (typeof _userInfo.validadeToken == "string") {
      _userInfo.validadeToken = new Date(_userInfo.validadeToken);
    }

    if (_userInfo.validadeToken < dataCorrente) {
      localStorage.removeItem("User_Info");
      localStorage.removeItem("Token");
      window.location.reload();
    }
  }
  static getPrefeitura() {
    this.controlarValidadeToken();

    if (!UserInfo.gerenciaPrefeitura()) {
      return _userInfo.prefeituraId;
    }

    if (_userInfo.prefeituraSelecionadaId === undefined) {
      return 0;
    }

    return _userInfo.prefeituraSelecionadaId;
  }

  static getMunicipioId() {
    this.controlarValidadeToken();

    return _userInfo.municipioId;
  }

  static possuiPerfil(perfis) {
    this.controlarValidadeToken();

    return perfis.indexOf(_userInfo.perfil) > -1;
  }

  static possuiSubPerfil(subPerfil) {
    this.controlarValidadeToken();
    return _userInfo.subPerfil.indexOf(subPerfil) > -1;
  }

  static nomeUsuarioLogado() {
    this.controlarValidadeToken();
    return _userInfo.nome;
  }

  static getUsuarioId() {
    this.controlarValidadeToken();

    if (_userInfo.usuarioId === undefined) {
      return 0;
    }

    return _userInfo.usuarioId;
  }

  static eSuporte() {
    this.controlarValidadeToken();

    if (_userInfo.usuarioId === undefined) {
      return false;
    }
    
    return _userInfo.perfil === "trimap";
  }
}

let _fnForceAppUpdateView;

export function setForcarUpdate(fnForceAppUpdateView) {
  _fnForceAppUpdateView = fnForceAppUpdateView;
}

export function forcarUpdate() {
  if (_fnForceAppUpdateView) {
    _fnForceAppUpdateView();
  }
}
